<cass-core-toolbar></cass-core-toolbar>
<div class="page-container">
	<mat-card class="branding--title-card">
		<mat-card-content>
			<div class="title-card">
				<h1>{{ "USERS.FORGOT_PASSWORD.PAGE_TITLE" | translate }}</h1>
			</div>
		</mat-card-content>
	</mat-card>
	<mat-card class="branding--section-card">
		<mat-card-content>
			<ng-container *ngIf="emailVerificationRequired">
				<p class="form-description">{{ "FORGOT_PASSWORD.RESET_PASSWORD_INSTRUCTION" | translate }}</p>
				<form [formGroup]="enterEmailForm">
					<mat-form-field>
						<mat-label>{{ "USERS.FORGOT_PASSWORD.FORM_LABEL_ENTER_EMAIL" | translate }}</mat-label>
						<input matInput formControlName="email" id="email" name="email" autocomplete="username">
						<mat-error cassErrorForFormControlName="email"></mat-error>
					</mat-form-field>
					<div class="button-container">
						<button mat-raised-button color="primary" type="submit" (click)="sendVerificationEmail()">{{ "USERS.FORGOT_PASSWORD.ACTION_SEND_VERIFICATION_EMAIL" | translate }}</button>
					</div>
				</form>
			</ng-container>
			<ng-container *ngIf="!emailVerificationRequired && passwordChangeRequired">
				<p class="form-description">{{ "FORGOT_PASSWORD.FORGOT_PASSWORD_MESSAGE" | translate: { email_address: enterEmailForm.get("email")?.value } }}</p>
				<form [formGroup]="changePasswordForm">
					<mat-form-field>
						<mat-label>{{ "USERS.FORGOT_PASSWORD.FORM_LABEL_VERIFICATION_CODE" | translate }}</mat-label>
						<input matInput required formControlName="verificationCode" id="verification-code" name="verification-code" autocomplete="one-time-code">
						<mat-error cassErrorForFormControlName="verificationCode"></mat-error>
					</mat-form-field>

					<mat-form-field>
						<mat-label>{{ "USERS.COMMON.FORM_LABEL_ENTER_NEW_PASSWORD" | translate }}</mat-label>
						<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" formControlName="newPassword" id="new-password" name="new-password" autocomplete="new-password">
						<button mat-icon-button matSuffix type="button" (click)="isPasswordShown = !isPasswordShown">
							<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
						</button>
						<mat-error cassErrorForFormControlName="newPassword"></mat-error>
					</mat-form-field>

					<mat-form-field>
						<mat-label>{{ "USERS.COMMON.FORM_LABEL_CONFIRM_NEW_PASSWORD" | translate }}</mat-label>
						<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" formControlName="confirmPassword" id="confirm-password" name="confirm-password" autocomplete="new-password">
						<button mat-icon-button matSuffix type="button" (click)="isPasswordShown = !isPasswordShown">
							<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
						</button>
						<mat-error cassErrorForFormControlName="confirmPassword"></mat-error>
					</mat-form-field>
					<div class="button-container">
						<button mat-raised-button color="primary" type="submit" (click)="sendChangePasswordRequest()">{{ "USERS.FORGOT_PASSWORD.ACTION_CHANGE_PASSWORD" | translate }}</button>
					</div>
				</form>
			</ng-container>
			<ng-container *ngIf="passwordChanged">
				<p class="form-description">{{ "FORGOT_PASSWORD.CHANGE_PASSWORD_SUCCESS_MESSAGE" | translate }}</p>
				<div class="button-container">
					<button mat-raised-button color="primary" type="submit" (click)="goToLoginPage()">{{ "LOGIN.LOGIN_BUTTON_LABEL" | translate }}</button>
				</div>
			</ng-container>
</mat-card-content>
	</mat-card>
</div>
